import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import ErrorPage from "Components/Shared/error";
import Loading from "Components/Shared/loading";
import StickyHeadTable from "Components/Shared/table";
import { useQuery } from "react-query";
import { request } from "Utils";
import Usermenu from "./menu";
import NoContentFound from "Components/Shared/noContentFound";
import AddConfig from "./add";
import { useDailog, useToast } from "Utils/hooks";
import Toast from "Components/Shared/toast";
import { SupportInt } from "./type";

const getAdmin = async () => {
  const { result } = await request.get({
    url: "/support/emergency_numbers/",
  });
  return result;
};

const SupportCommunity = () => {
  const { isOpen, closeDialog, openDialog } = useDailog();
  const { toggleToast, toastMessage } = useToast();
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["Users"],
    queryFn: getAdmin,
    retry: 2,
    // staleTime: 86400000,
  });

  const columns = [
    { minWidth: 20, name: "No", key: "index" },
    { minWidth: 50, name: "Number", key: "phone_number" },
    { minWidth: 50, name: "Country", key: "country" },
    { minWidth: 50, name: "Action", key: "action" },
  ];

  const users = data?.map((support: SupportInt, index: number) => ({
    index: ++index,
    ...support,
    action: (
      <Usermenu
        refetch={refetch}
        data={support as SupportInt}
        toggleToast={toggleToast}
        isSupperAdmin={true}
      />
    ),
  }));
  if (isLoading) return <Loading />;
  if (error) return <ErrorPage error={error} />;
  return (
    <>
      <Container maxWidth="lg">
        <Box textAlign="right" mb={3}>
          <Button variant="contained" onClick={openDialog}>
            Add New Emergency Line
          </Button>
        </Box>
        {users?.length ? (
          <Box pb={5} sx={{ height: users?.length <= 7 ? "77vh" : "" }}>
            <StickyHeadTable
              refetch={refetch}
              data={users}
              dataLength={data?.totalCount}
              columns={columns}
              //   setLimit={setLimit}
              //   limit={limit}
              //   setPageId={setPageId}
              //   pageId={pageId}
              // pageCount={data.pageCount}
            />
          </Box>
        ) : (
          <NoContentFound />
        )}
      </Container>
      <AddConfig
        isOpen={isOpen}
        closeDialog={closeDialog}
        toggleToast={toggleToast}
        refetch={refetch}
      />
      {Boolean(toastMessage) && (
        <Toast
          open={Boolean(toastMessage)}
          message={toastMessage}
          onClose={() => toggleToast("")}
        />
      )}
    </>
  );
};

export default SupportCommunity;
